module.exports = __webpack_public_path__ + "img/d2a1240.png";